<template>
  <div class="modal-reserve-price-container">
    <sweet-modal ref="modal" overlay-theme="dark">
      <div class="modal-title">가격/인원 설정</div>
      <template v-if="item">
        <admin-form-item label="적용 기간">
          <div class="flex" style="flex-wrap:wrap">
            <div style="align-items: center;">
              <admin-date-picker
                type="date"
                :data="item.start_date"
                @setDate="date => item.start_date = date"></admin-date-picker>
            </div>
            <div class="lp-dating">&#126;</div>
            <div style="align-items: center;">
              <admin-date-picker
                type="date"
                :data="item.end_date"
                @setDate="date => item.end_date = date"></admin-date-picker>
            </div>
          </div>
        </admin-form-item>
        <admin-form-item label="가격 설정" style="margin-top:32px">
          <table>
            <tr>
              <th style="width:30%">기본 정가 설정</th>
              <th style="width:20%">할인여부</th>
              <th style="width:20%">할인가격</th>
              <th style="width:30%">할인 후 가격</th>
            </tr>
            <tr>
              <td>
                <div class="flex-align" style="gap:4px">
                  <input type="number" v-model="item.price">원
                </div>
              </td>
              <td>
                <select class="input-border" v-model="item.discount_type">
                  <option :value="-1">할인없음</option>
                  <option :value="0">할인율</option>
                  <option :value="1">금액할인</option>
                </select>
              </td>
              <td>
                <div class="flex-align" style="gap:4px">
                  <input v-if="item.discount_type === -1" type="number" disabled>
                  <template v-else-if="item.discount_type === 0">
                    <input type="number" v-model="item.discount_rate">%
                  </template>
                  <template v-else-if="item.discount_type === 1">
                    <input type="number" v-model="item.discount_price">원
                  </template>
                </div>
              </td>
              <td>
                <div style="text-align:right">{{ currency(item.sale_price) }}</div>
              </td>
            </tr>
          </table>
          <div class="size-13 sub1" style="margin-top:32px">*기본 가격 등록 후, 상품 일정에서 각 일자별로 재고와 가격을 수정하실 수 있습니다.</div>
        </admin-form-item>

        <div class="btn-group-justify-end" style="padding-top:40px">
          <button class="button is-light" @click="clickCancel">취소</button>
          <button class="button is-primary" @click="clickAccept">저장</button>
        </div>
      </template>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  export default {
    name: 'ModalReservePrice',
    components: {
      SweetModal
    },
    props: {
      price: {
        type: Object
      }
    },
    created() {

    },
    data() {
      return {
        item: undefined
      }
    },
    watch: {
      'item.price'(n) {
        this.item.price = Number(n);
        this.calcSalePrice();
      },
      'item.discount_type'(n) {
        this.item.is_discount = n > -1;
        this.calcSalePrice();
      },
      'item.discount_price'(n) {
        this.item.discount_price = Number(n);
        this.calcSalePrice();
      },
      'item.discount_rate'(n) {
        this.item.discount_rate = Number(n);
        this.calcSalePrice();
      }
    },
    methods: {
      calcSalePrice() {
        if(this.item.is_discount) {
          if(this.item.discount_type === 0) {
            this.item.sale_price = this.item.price - (this.item.price * (this.item.discount_rate/100));
          } else {
            this.item.sale_price = this.item.price - this.item.discount_price;
          }
        } else {
          this.item.sale_price = this.item.price;
        }
      },
      init() {
        this.item = {
          start_date: '',
          end_date: '',
          price: 0,
          sale_price: 0,
          is_discount: false,
          discount_type: -1,
          discount_rate: 0,
          discount_price: 0
        };
      },
      open() {
        setTimeout(()=>{
          if(this.price) {
            this.item = this.cloneItem(this.price);
          } else {
            this.init();
          }
          this.$refs.modal.open();
        },100);
      },
      close() {
        this.$refs.modal.close();
      },
      clickCancel() {
        this.close();
      },
      clickAccept() {
        if(this.valid()) {
          let item = this.cloneItem(this.item);
          if(this.item.id) {
            this.$emit('update', item);
          } else {
            this.$emit('add', item);
          }
          this.close();
        }
      },
      valid() {
        let msg = '';
        if(!this.item.start_date || this.item.start_date === '') {
          msg = '시작일을 선택해주세요.';
        }
        else if(this.item.price === 0) {
          msg = '기본 정가를 입력해주세요.';
        }

        if(msg !== '') {
          this.toast(msg);
        }

        return msg === '';
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .modal-reserve-price-container
    color #363636
  .modal-title
    font-size 20px
    font-weight 700
    margin-bottom 36px

  .modal-reserve-price-container
    table,th,td
      border 0
    th
      border-bottom 1px solid #eeeeee
    th,td
      padding 12px
      font-size 14px
      font-weight 400
    td
      text-align center

  .input-border
    padding 4px 7px
  input
    flex 1
  .sub1
    color #787878
</style>
<style lang="stylus">
  .modal-reserve-price-container
    .sweet-modal.is-alert
      width 764px
      max-height 90vh
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 16px 32px
</style>
